import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React from 'react';

import { columnWidthsItemDesktop } from '../../constants';
import { HighlightableText } from '../HighlightableText';
import { ItemDate } from '../ItemDate';

import { TradingListItemTypes } from '.';

export const TradingListItemDesktop: React.FC<TradingListItemTypes.Content> = ({
  item,
  isLast,
  operationChanged,
  positionChanged,
  saleQtyChanged,
  purchaseQtyChanged,
  executeQtyChanged,
  lastUpdatedAt,
}) => {
  const [openAccordion, setOpenAccordion] = React.useState('closed');
  const handlePress = () => {
    setOpenAccordion(openAccordion === 'closed' ? 'opened' : 'closed');
  };
  return (
    <VStack marginBottom={Spacing['inset.sm']}>
      <HStack
        paddingX={Spacing['inset.xs']}
        justifyContent="space-between"
        marginBottom={Spacing['inset.nano']}
        marginX={Spacing['inset.sm']}
        paddingY={Spacing['inset.xs']}>
        <VStack
          px={Spacing['inline.nano']}
          py={Spacing['inset.xs']}
          width={columnWidthsItemDesktop.paper}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            flex={1}
            textAlign="start">
            {item.paper}
          </Text>
        </VStack>
        <VStack
          px={Spacing['inline.nano']}
          py={Spacing['inset.xs']}
          width={columnWidthsItemDesktop.date}>
          <ItemDate updatedAtDto={item.date} updatedAtDynamic={lastUpdatedAt} />
        </VStack>
        <VStack
          px={Spacing['inline.nano']}
          py={Spacing['inset.xs']}
          width={columnWidthsItemDesktop.purchaseQty}>
          <HighlightableText shouldHighlight={purchaseQtyChanged}>
            {item.purchaseQty}
          </HighlightableText>
        </VStack>
        <VStack
          px={Spacing['inline.nano']}
          py={Spacing['inset.xs']}
          width={columnWidthsItemDesktop.saleQty}>
          <HighlightableText shouldHighlight={saleQtyChanged}>{item.saleQty}</HighlightableText>
        </VStack>
        <VStack
          px={Spacing['inline.nano']}
          py={Spacing['inset.xs']}
          width={columnWidthsItemDesktop.executedQty}>
          <HighlightableText shouldHighlight={executeQtyChanged}>
            {item.executedQty}
          </HighlightableText>
        </VStack>
        <VStack
          px={Spacing['inline.nano']}
          py={Spacing['inset.xs']}
          width={columnWidthsItemDesktop.position}>
          <HighlightableText shouldHighlight={positionChanged}>{item.position}</HighlightableText>
        </VStack>
        <VStack
          px={Spacing['inline.nano']}
          py={Spacing['inset.xs']}
          width={columnWidthsItemDesktop.operation}>
          <Pressable onPress={handlePress}>
            <HStack maxWidth="80%" flexDir="row">
              <HighlightableText shouldHighlight={operationChanged}>
                {item.operation}
              </HighlightableText>
              <Icon
                testID="action-icon"
                name={openAccordion === 'opened' ? 'ChevronUp' : 'ChevronDown'}
                size="xxs"
                color={Color['brand.primary.dark']}
              />
            </HStack>
          </Pressable>
        </VStack>
      </HStack>
      <Box
        width="100%"
        borderBottomWidth={openAccordion === 'opened' ? 0 : isLast ? 0 : 1}
        borderBottomColor={Color['neutral.lightest']}
      />
      {openAccordion === 'opened' && (
        <>
          {item?.tradings?.map((itemTrading, index) => (
            <HStack
              width="100%"
              key={`${index}`}
              borderRadius="sm"
              paddingX={Spacing['inset.xs']}
              marginX={Spacing['inset.sm']}
              backgroundColor={Color.background}
              justifyContent="space-between"
              paddingY={Spacing['inset.nano']}>
              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Operação
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start">
                  {itemTrading.operation}
                </Text>
              </VStack>

              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Qtd. executadas
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start">
                  {itemTrading.executedQty}
                </Text>
              </VStack>

              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Preço executado
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start">
                  {itemTrading.executedPrice}
                </Text>
              </VStack>

              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Mercado
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start">
                  {itemTrading.market}
                </Text>
              </VStack>

              <VStack width="20%" px={Spacing['inline.nano']} py={Spacing['inset.xs']}>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.semibold']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start"
                  paddingBottom={Spacing['inset.quarck']}>
                  Status
                </Text>
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  fontWeight={Typography['fontweight.regular']}
                  fontSize={Typography['fontsize.md']}
                  flex={1}
                  textAlign="start">
                  {itemTrading.status}
                </Text>
              </VStack>
            </HStack>
          ))}
        </>
      )}
    </VStack>
  );
};
